import {
  USER_LOGOUT_REQUEST,
  USER_LOGOUT_SUCCESS,
  USER_LOGOUT_FAILURE,
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAILURE,
  USER_REGISTER_REQUEST,
  USER_REGISTER_SUCCESS,
  USER_REGISTER_FAILURE,
  CHANGE_FORM,
  EDIT_PROFILE_REQUEST,
  EDIT_PROFILE_SUCCESS,
  EDIT_PROFILE_FAILURE,
  PAGE_UNLOAD,
  DEACTIVATE
} from '../constants';

const initialState = {
  formState: {
    username: '',
    password: '',
    firstName: '',
    lastName: '',
    gender: '',
    phone: '',
    address: '',
    billing_address: '',
    image: ''
  },
  errorMessage: '',
  isFetching: false,
  user: {},
  package: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case USER_LOGOUT_REQUEST:
      return { ...state, isFetching: true, formState: initialState.formState };
    case USER_LOGOUT_SUCCESS:
      return initialState;
    case USER_LOGOUT_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.payload };
    case USER_LOGIN_REQUEST:
      return { ...state, isFetching: true, formState: initialState.formState };
    case USER_LOGIN_SUCCESS:
      return {
        ...state,
        isFetching: false,
        user: action.payload.user,
        package: action.payload.package,
        errorMessage: ''
      };
    case USER_LOGIN_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload.response.errorMessage
      };
    case USER_REGISTER_REQUEST:
      return { ...state, isFetching: true, formState: initialState.formState };
    case USER_REGISTER_SUCCESS:
      return { ...state, isFetching: false, errorMessage: '' };
    case USER_REGISTER_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload.response.errorMessage
      };
    case CHANGE_FORM:
      return { ...state, formState: action.newState };
    case EDIT_PROFILE_REQUEST:
      return { ...state, isFetching: true, formState: initialState.formState };
    case EDIT_PROFILE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        user: action.payload.user,
        errorMessage: ''
      };
    case EDIT_PROFILE_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload.response.errorMessage
      };
    case PAGE_UNLOAD:
      return { ...initialState, user: state.user, package: state.package };
    case DEACTIVATE:
      return initialState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/auth.js